import * as React from 'react';
import Card from './Card';
import '../css/expandable-card.sass';
import LinkButton from './LinkButton';

interface ExpandableCardProps {
  children: React.ReactNode;
  maxHeight?: string;
  expand?: boolean;
  moreLinkLbl?: string;
  lessLinkLbl?: string;
}

interface ExpandableCardState {
  expand: boolean;
  height: string;
}

export default function ExpandableCard(props: ExpandableCardProps) {
  const {
    maxHeight = '500',
    moreLinkLbl = 'More',
    lessLinkLbl = 'Less'
  } = props;
  const height = () => {
    const returnedHeight =
      window.innerWidth > 992 ? +maxHeight : +maxHeight / 2;
    return `${returnedHeight}px`;
  };
  const [state, setState] = React.useState<ExpandableCardState>({
    expand: !!props.expand,
    height: props.expand ? 'auto' : height()
  });
  const ref: any = React.useRef();

  const onLessClick = () =>
    ref.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  React.useEffect(() => {
    setState({ ...state, expand: !!props.expand });
  }, [props.expand]);

  React.useEffect(() => {
    if (state.expand) {
      setState({ ...state, height: 'auto' });
    } else {
      setState({ ...state, height: height() });
    }
  }, [state.expand]);

  return (
    <div className="expandable-card" ref={ref}>
      <Card>
        <div
          style={{ height: state.height }}
          className={!state.expand ? 'content' : ''}
        >
          {props.children}
        </div>
        <div className="alignBtn">
          <LinkButton
            name="expand-btn"
            id="expand-btn"
            smol
            onClick={() => {
              if (state.expand) {
                onLessClick();
              }
              setState({ ...state, expand: !state.expand });
            }}
          >
            {state.expand ? lessLinkLbl : moreLinkLbl}
          </LinkButton>
        </div>
      </Card>
    </div>
  );
}
